// #region Imports
import React, { useEffect, useState } from 'react';
import './ComissaoCrud.scss';
import { buildComissao } from '../../../pages/Comissoes/comissao-utils';
// #endregion

export default function ComissaoCrud({ open, comissao, onClose, onSave, funcionarios = [], vendas = [] }) {
  // #region Estado
  const [form, setForm] = useState(buildComissao());
  // #endregion

  // #region Efeitos
  useEffect(() => { setForm(buildComissao(comissao || {})); }, [comissao, open]);
  // #endregion

  if (!open) return null;

  // #region Handlers
  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.funcionario_id || !form.venda_id || !form.valor) return;
    onSave({
      ...form,
      funcionario_id: Number(form.funcionario_id),
      venda_id: Number(form.venda_id),
      valor: Number(form.valor),
    });
  }
  // #endregion

  // #region Render
  return (
    <div
      className="crud-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={form.id ? 'Editar Comissão' : 'Nova Comissão'}
    >
      <div className="crud-modal">
        <header className="crud-header">
          <h3>{form.id ? 'Editar Comissão' : 'Nova Comissão'}</h3>
          <button
            type="button"
            className="close-btn"
            onClick={onClose}
            aria-label="Fechar"
          >
            ×
          </button>
        </header>
        <form onSubmit={handleSubmit} className="crud-form">
          <div className="form-grid">
            <div className="form-field">
              <label>Funcionário *</label>
              <select
                name="funcionario_id"
                value={form.funcionario_id || ''}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                {funcionarios.map(f => (
                  <option key={f.id} value={f.id}>{f.nome}</option>
                ))}
              </select>
            </div>
            <div className="form-field">
              <label>Venda *</label>
              <select
                name="venda_id"
                value={form.venda_id || ''}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                {vendas.map(v => (
                  <option key={v.id} value={v.id}>#{v.id}</option>
                ))}
              </select>
            </div>
            <div className="form-field">
              <label>Data de Competência *</label>
              <input
                type="date"
                name="data_competencia"
                value={form.data_competencia}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label>Valor da Comissão *</label>
              <input
                type="number"
                step="0.01"
                name="valor"
                value={form.valor}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="form-section inline">
            <label className="checkbox-field">
              <input
                type="checkbox"
                name="pago"
                checked={form.pago}
                onChange={handleChange}
              />
              <span>Comissão Paga</span>
            </label>
          </div>
          <footer className="crud-actions">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              {form.id ? 'Salvar' : 'Criar Comissão'}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
  // #endregion
}
